class Accordion {
	/**
	 * Adds click event listeners to all accordion toggle buttons.
	 */
	onClickListenerAccordionButton() {
		for (const item of Array.from(document.querySelectorAll('[data-js="accordion-toggle"]'))) {
			item.addEventListener('click', this.toggleAccordionPanel);
		}
	}

	/**
	 * Toggles the visibility of the accordion panel and updates ARIA attributes.
	 * @param {Event} event - The click event triggered by the accordion button.
	 */
	toggleAccordionPanel(event) {
		const accordionButton = event.target;
		const accordionPanel = accordionButton.parentNode.nextElementSibling;
		accordionPanel.classList.toggle('c-accordion__panel--visible');
		accordionButton.firstElementChild.classList.toggle('c-accordion__caret-icon--opened');

		if (accordionButton.getAttribute('aria-expanded') === 'false') {
			accordionButton.setAttribute('aria-expanded', 'true');
			accordionButton.parentNode.nextElementSibling.setAttribute('aria-hidden', 'false');
		} else {
			accordionButton.setAttribute('aria-expanded', 'false');
			accordionButton.parentNode.nextElementSibling.setAttribute('aria-hidden', 'true');
		}
	}

	/**
	 * Initializes the accordion component by adding event listeners.
	 */
	init() {
		this.onClickListenerAccordionButton();
	}
}

export default Accordion;
